import React, { useState } from "react";
import "./Header.scss";
import NCLOGO from "./Logo.png";
import { IoIosArrowDown } from "react-icons/io";
import { IoMdMenu } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import { useNavigate, useLocation } from "react-router-dom";
const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [ShowTooltip, setShowTooltip] = useState();
    const toggleMenu = () => { setIsMenuOpen(!isMenuOpen); };
    const isActive = (path) => location.pathname.includes(path);
    return (
        <>
            <div className="Home-Header-Maindiv">
                <div className="dflex alignitems JSBetween Logos">
                    <img src={NCLOGO} alt="NCLLogo" className="LOGO" />

                    <div className="HMenu dflex alignitems gap-3 " >
                        <span onClick={() => navigate("/")} >Home</span>
                        <span onClick={() => navigate("/AboutUs")} className={isActive("/AboutUs") && "Web-Header-Active"}> About </span>
                        <span onClick={() => navigate("/Teams")} className={isActive("/Teams") && "Web-Header-Active"}> Team </span>
                        <span style={{ position: "relative" }}
                            onMouseEnter={() => setShowTooltip("Gallery")}
                            onMouseLeave={() => setShowTooltip()}> Gallery <IoIosArrowDown />
                            {ShowTooltip === "Gallery" && (
                                <div className="Card dflex flexd-column SubMenu p-0" >
                                    <span onClick={() => navigate("/Student Engagement")} className={isActive("/Student%20Engagement") && "Web-Header-Active"}> Student Engagement </span>
                                    <span onClick={() => navigate("/Partnerships")} className={isActive("/Partnerships") && "Web-Header-Active"}> Partnerships & Initiatives </span>
                                    <span onClick={() => navigate("/Publications")} className={isActive("/Publications") && "Web-Header-Active"}> Publications </span>
                                </div>
                            )}
                        </span>
                        <span style={{ position: "relative" }}
                            onMouseEnter={() => setShowTooltip("Programs")}
                            onMouseLeave={() => setShowTooltip()}
                        > Programs <IoIosArrowDown />
                            {ShowTooltip === "Programs" && (
                                <div className="Card dflex flexd-column SubMenu p-0" >
                                    <span onClick={() => navigate("/Programs/Scholarships")}> Scholarships </span>
                                    <span onClick={() => navigate("/Programs/Skills")}> Skill Development </span>
                                    <span onClick={() => navigate("/Programs/Seva")}> Seva (Community Service) </span>
                                    <span onClick={() => navigate("/Programs/MMPrograms")}> Mentor Mentee </span>
                                    <span onClick={() => navigate("/Programs/MHWellbeing")}> Mental Health & Wellbeing </span>
                                </div>
                            )}
                        </span>
                        <span onClick={() => navigate("/Contact Us")} className={isActive("/Contact%20Us") && "Web-Header-Active"}> Contact Us </span>

                    </div>

                    <div className="NSF-SItes dflex gap-3">
                        <span onClick={() => window.open("https://www.northsouth.org/", "_blank")} >NorthSouth USA </span>
                        <span onClick={() => window.open("https://india.northsouth.org/", "_blank")} > NSF India </span>


                    </div>
                    <div className="dflex alignitems">
                        <div className=" dflex gap-3 DL_Buttons">
                            <button className="Website-Buttons" onClick={() => navigate("/Donate")} > Sponsor a Student </button>
                            <span style={{ position: "relative" }}
                                onMouseEnter={() => setShowTooltip("Login")}
                                onMouseLeave={() => setShowTooltip()}>
                                <button className="Website-Buttons" onClick={() => window.open("https://portal.northsouth.org/app6/MainTest.aspx?_gl=1*1s55zv0*_ga*MzU0MjY2NjQzLjE3NDcyMTcxOTg.*_ga_NFGY5F210T*czE3NzM3NDEwNTYkbzkwJGcwJHQxNzczNzQxMDU2JGo2MCRsMCRoOTYwNzkzOTI4", "_blank")} > Log in  </button>
                                {/* {ShowTooltip === "Login" && ( <IoIosArrowDown />
                                    <div className="Card dflex flexd-column Login-SubMenu p-0" >
                                        <span > Scholarships </span>
                                        <span onClick={() => window.open("https://ncl.northsouth.org/", "_blank")}>NCL Assessments </span>
                                    </div>
                                )} */}
                            </span>
                        </div>
                        <button className="menu-toggle" onClick={toggleMenu}> <IoMdMenu /> </button>
                    </div>
                </div>


            </div>
            <div className={`sidebar ${isMenuOpen ? "open" : ""}`}>
                <button className="close-btn" onClick={toggleMenu}>
                    <IoMdClose />{" "}
                </button>
                <div
                    className="dflex flexd-column gap-3 "
                    style={{ alignItems: "flex-start" }}
                >
                    <span onClick={() => navigate("/")}>Home</span>
                    <span onClick={() => navigate("/AboutUs")}> About </span>
                    <span onClick={() => navigate("/Teams")}> Team </span>
                    <span onClick={() => navigate("/Publications")} className={isActive("/Publications") && "Web-Header-Active"} style={{ position: "relative" }}
                        onMouseEnter={() => setShowTooltip("Gallery")}
                        onMouseLeave={() => setShowTooltip()}> Gallery <IoIosArrowDown />
                        {ShowTooltip === "Gallery" && (
                            <div className="Card dflex flexd-column SubMenu p-0" >
                                <span onClick={() => navigate("/Student Engagement")} className={isActive("/Student%20Engagement") && "Web-Header-Active"}> Student Engagement </span>
                                <span onClick={() => navigate("/Partnerships")} className={isActive("/Partnerships") && "Web-Header-Active"}> Partnerships & Initiatives </span>
                                <span onClick={() => navigate("/Publications")} className={isActive("/Publications") && "Web-Header-Active"}> Publications </span>
                            </div>
                        )}
                    </span>
                    <span style={{ position: "relative" }}
                        onClick={() => setShowTooltip(ShowTooltip === "Publications" ? "" : "Publications")}
                    >
                        Programs <IoIosArrowDown />
                        {ShowTooltip === "Publications" && (
                            <div className="Card dflex flexd-column SubMenu mt-1">
                                <span onClick={() => navigate("/Programs/Scholarships")}> Scholarships </span>
                                <span onClick={() => navigate("/Programs/Skills")}> Skill Development </span>
                                <span onClick={() => navigate("/Programs/Seva")}> Seva (Community Service) </span>
                                <span onClick={() => navigate("/Programs/MMPrograms")}> Mentor Mentee </span>
                                <span onClick={() => navigate("/Programs/MHWellbeing")}> Mental Health & Wellbeing </span>
                            </div>
                        )}
                    </span>
                    <span onClick={() => navigate("/Contact Us")}> Contact Us </span>

                    <div className="Side_NSF-SItes dflex gap-3 flexd-column w-100">
                        <span onClick={() => window.open("https://www.northsouth.org/", "_blank")} > NorthSouth USA </span>
                        <span onClick={() => window.open("https://india.northsouth.org/", "_blank")} > NSF India </span>

                    </div>
                    <div className=" dflex gap-3 Side_DL_Buttons flexd-column w-100">
                        <button className="Website-Buttons " onClick={() => navigate("/Donate")} > Sponsor a Student </button>
                        <span style={{ position: "relative" }}
                            onMouseEnter={() => setShowTooltip("Login")}
                            onMouseLeave={() => setShowTooltip()}>
                            <button className="Website-Buttons w-100" onClick={() => window.open("https://portal.northsouth.org/app6/MainTest.aspx?_gl=1*1s55zv0*_ga*MzU0MjY2NjQzLjE3NDcyMTcxOTg.*_ga_NFGY5F210T*czE3NzM3NDEwNTYkbzkwJGcwJHQxNzczNzQxMDU2JGo2MCRsMCRoOTYwNzkzOTI4", "_blank")} > Log in  </button>
                            {/* {ShowTooltip === "Login" && (<IoIosArrowDown />
                                <div className="Card dflex flexd-column Login-SubMenu p-0" >
                                    <span > Scholarships </span>
                                    <span onClick={() => window.open("https://ncl.northsouth.org/", "_blank")}>NCL Assessments </span>
                                </div>
                            )} */}
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
};
export default Header;